const sources = document.querySelector('.js-sources');

function setLabel() {
  const button = sources.querySelector('.sources__button');
  const labelSpan = button.querySelector('span');
  const labelOpen = button.dataset.openlabel;
  const labelClose = button.dataset.closelabel;

  if (sources.hasAttribute('data-collapse')) {
    labelSpan.textContent = labelOpen;
    button.setAttribute('title', labelOpen);
  } else {
    labelSpan.textContent = labelClose;
    button.setAttribute('title', labelClose);
  }
}

function init() {
  if (sources) {
    sources.setAttribute('data-collapse', true);
    setLabel();

    const button = sources.querySelector('.sources__button');
    button.addEventListener('click', () => {
      sources.toggleAttribute('data-collapse');
      setLabel();
    });
  }
}

export { init };
